/* IFZ MOTION — Iron Fit motion/polish layer (thedigitalsouq recipe, no libraries).
   Self-contained: injects its own CSS, runs once-only scroll reveals.
   Safe by design: if this file fails to load, the site looks exactly as before. */
(function () {
  if (window.__ifzMotion) return; window.__ifzMotion = 1;

  var EASE = 'cubic-bezier(.22,1,.36,1)';
  var css = '' +
  '@media (prefers-reduced-motion: no-preference){' +

  /* ---------- scroll reveals ---------- */
  '.ifzm-r{opacity:0;transform:translateY(24px);transition:opacity .6s ' + EASE + ',transform .6s ' + EASE + ';will-change:transform}' +
  '.ifzm-r.ifzm-in{opacity:1;transform:none}' +

  /* ---------- primary buttons: lift + saturate + green glow ---------- */
  '.ifz-btn--primary,.ifz-pcard__cta,.ifq__btn--primary,.ifb__primary,.ifzd__go,.ifc-cod-btn,.ifz-btn--ghost,.ifq__btn--ghost,.ifz-ecard__cta{' +
    'transition:transform .22s ' + EASE + ',box-shadow .22s ' + EASE + ',filter .22s,background .2s,color .2s,border-color .2s}' +
  '.ifz-btn--primary:hover,.ifz-pcard__cta:hover,.ifq__btn--primary:hover,.ifb__primary:hover,.ifzd__go:hover,.ifc-cod-btn:hover{' +
    'transform:translateY(-2px);filter:saturate(1.06) brightness(1.06);box-shadow:0 14px 34px rgba(240, 180, 41,.32)}' +
  '.ifz-btn--ghost:hover,.ifq__btn--ghost:hover,.ifz-ecard__cta:hover{transform:translateY(-2px)}' +
  '.ifz-btn--primary:active,.ifz-pcard__cta:active,.ifq__btn--primary:active,.ifb__primary:active,.ifzd__go:active,.ifc-cod-btn:active{' +
    'transform:translateY(0) scale(.985);transition-duration:.09s}' +

  /* ---------- cards: deeper lift + soft shadow + media zoom ---------- */
  '.ifz-pcard,.ifz-ecard,.ifz-fitbox__card,.ifq__card{transition:transform .32s ' + EASE + ',box-shadow .32s ' + EASE + ',border-color .25s}' +
  '.ifz-pcard:hover{transform:translateY(-7px);box-shadow:0 22px 44px rgba(0,0,0,.5),0 8px 22px rgba(240, 180, 41,.14);border-color:rgba(240, 180, 41,.55)}' +
  '.ifz-ecard:hover{transform:translateY(-5px);box-shadow:0 16px 34px rgba(0,0,0,.45);border-color:rgba(240, 180, 41,.55)}' +
  '.ifz-fitbox__card:hover,.ifq__card:hover{transform:translateY(-4px);box-shadow:0 14px 30px rgba(0,0,0,.4)}' +
  '.ifz-pcard__media img,.ifz-ecard__media img{transition:transform .5s ' + EASE + '}' +
  '.ifz-pcard:hover .ifz-pcard__media img{transform:scale(1.05)}' +
  '.ifz-ecard:hover .ifz-ecard__media img{transform:scale(1.06)}' +
  '.ifb-core{transition:transform .28s ' + EASE + ',box-shadow .28s ' + EASE + ',border-color .2s,background .2s}' +
  '.ifb-core:hover{transform:translateY(-3px)}' +

  /* ---------- header: nav underline slide, cart/wa lift ---------- */
  '.ifz-hd__nav a,.ifq-hd__nav a,.ifxg-hd__nav a{position:relative}' +
  '.ifz-hd__nav a:after,.ifq-hd__nav a:after,.ifxg-hd__nav a:after{content:"";position:absolute;left:0;right:100%;bottom:-4px;height:2px;border-radius:2px;background:#f0b429;transition:right .28s ' + EASE + '}' +
  '.ifz-hd__nav a:hover:after,.ifq-hd__nav a:hover:after,.ifxg-hd__nav a:hover:after{right:0}' +
  '.ifz-hd__cart,.ifq-hd__cart,.ifxg-hd__cart,.ifz-hd__wa,.ifq-hd__wa,.ifxg-hd__wa{transition:transform .2s ' + EASE + ',box-shadow .2s,background .2s,color .2s,border-color .2s}' +
  '.ifz-hd__cart:hover,.ifq-hd__cart:hover,.ifxg-hd__cart:hover,.ifz-hd__wa:hover,.ifq-hd__wa:hover,.ifxg-hd__wa:hover{transform:translateY(-2px)}' +

  /* ---------- WhatsApp FAB ---------- */
  '.ifz-fab{transition:transform .25s ' + EASE + ',box-shadow .25s ' + EASE + '}' +
  '.ifz-fab:hover{transform:translateY(-3px) scale(1.07);box-shadow:0 16px 36px rgba(37,211,102,.45)}' +

  /* ---------- ambient: hero CTA breath (shadow only) + hero settle ---------- */
  '@keyframes ifzm-pulse{0%,100%{box-shadow:0 14px 30px rgba(240, 180, 41,.26)}50%{box-shadow:0 16px 42px rgba(240, 180, 41,.48),0 0 0 8px rgba(240, 180, 41,.06)}}' +
  '.ifz-hero__cta .ifz-btn--primary{animation:ifzm-pulse 3.6s ease-in-out infinite}' +
  '@keyframes ifzm-heroIn{from{transform:scale(1.07)}to{transform:scale(1)}}' +
  '.ifz-hero:not(.ifz-hero--poster) .ifz-hero__bg img{animation:ifzm-heroIn 3.2s ' + EASE + ' both}' +
  'img.ifq-banner__bg{animation:ifzm-heroIn 3.2s ' + EASE + ' both}' +

  /* ---------- steps icons ---------- */
  '.ifz-steps__ic{transition:transform .3s ' + EASE + '}' +
  '.ifz-steps>*:hover .ifz-steps__ic{transform:translateY(-3px) scale(1.06)}' +

  /* ---------- Dawn pages (collections/search): card lift ---------- */
  '.card-wrapper{transition:transform .32s ' + EASE + ',box-shadow .32s ' + EASE + '}' +
  '.card-wrapper:hover{transform:translateY(-6px)}' +

  '}';

  var st = document.createElement('style');
  st.id = 'ifz-motion-css';
  st.textContent = css;
  /* append to BODY end, not head: section styles are inline in the body, and a later
     stylesheet wins specificity ties — this guarantees the motion rules take precedence */
  (document.body || document.head || document.documentElement).appendChild(st);

  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  /* Non-nested reveal targets. Sticky elements (header, builder summary, product sticky bar) deliberately excluded. */
  var SEL = [
    '.ifz-sec__t', '.ifz-sec__s', '.ifz-packs__note',
    '.ifz-pcard', '.ifz-ecard', '.ifz-fitbox__card',
    '.ifz-trust>*', '.ifz-steps>*',
    '.ifz-faq details', '.ifz-final__panel',
    '.ifq__card', '.ifq__desc-wrap', '.ifq__reassure>li',
    '.ifb__step'
  ].join(',');

  function init() {
    var vh = window.innerHeight || 800;
    var els = [];
    try {
      document.querySelectorAll(SEL).forEach(function (el) {
        /* only animate things clearly below the fold — nothing visible ever flashes */
        if (el.getBoundingClientRect().top > vh * 0.88) {
          el.classList.add('ifzm-r');
          els.push(el);
        }
      });
    } catch (e) { return; }
    if (!els.length) return;

    function finish(el, delay) {
      /* after the reveal, return the element to pristine styling so hover rules own it again */
      setTimeout(function () {
        el.classList.remove('ifzm-r', 'ifzm-in');
        el.style.transitionDelay = '';
        el.style.willChange = '';
      }, 650 + delay);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        /* stagger within the batch: index among not-yet-revealed siblings, capped like digitalsouq */
        var i = 0, p = el.parentElement;
        if (p) {
          for (var c = 0; c < p.children.length; c++) {
            var s = p.children[c];
            if (s === el) break;
            /* count preceding siblings still mid-reveal cycle (class removed after finish) */
            if (s.classList.contains('ifzm-r')) i++;
          }
        }
        var delay = Math.min(i * 70, 350);
        el.style.transitionDelay = delay + 'ms';
        el.classList.add('ifzm-in');
        finish(el, delay);
      });
    }, { rootMargin: '0px 0px -60px 0px', threshold: 0.05 });

    els.forEach(function (el) { io.observe(el); });

    /* safety valve: whatever never intersected (display:none rails etc.) un-hides after 8s */
    setTimeout(function () {
      els.forEach(function (el) {
        if (el.classList.contains('ifzm-r') && !el.classList.contains('ifzm-in')) {
          el.classList.remove('ifzm-r');
        }
      });
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
